module.exports = __webpack_public_path__ + "img/framee001.07fb7f97.jpg";